// Module
var code = `<div class="js-tradingCentral-tabs">
    {{#each items: num}}
        <div class="tradingCentral-tab-container" on-click="['tabStripItem', num]">
            <terceraLabel additionalClass="{{items[num].active?'tabItemLabel':'tabItemLabel-notActive'}}" width="{{num+1<items.length? tabWidth - 3: tabWidth}}" text="{{items[num].text}}"/>
        </div>
        
        <terceraComboBox items="{{cbItems[num]}}" name="cb{{num}}" visible="{{items[num].active && cbItems[num].length > 1}}" width="150" on-ComboItemClicked="['onComboItemClicked',num]" />
        
    {{/each}}
</div>


`;
// Exports
export default code;